import { AGSResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { AGSWin, AGSWinTypes } from "ags/integration/schema/ags-spin-response-schema";
import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import slotDefinition from "slotworks/model/slot-definition";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import Point from "slotworks/utils/geom/point";

export class ScatterResultBuilder extends AGSResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const win = data as AGSWin;
        return win.evaluationType && win.evaluationType === AGSWinTypes.SCATTER;
    }

    public build(record: Record, data: any): Result[] {
        const agsWin = data as AGSWin;
        const symbolDef = slotDefinition.symbolDefinitions[agsWin.symbolId];

        const result = new ScatterResult();
        result.symbolType = symbolDef.id;
        result.cashWon = agsWin.winAmount;

        result.positions = agsWin.winningSymbolsPositions.map((coords: number[]) => new Point(coords[0], coords[1]));
        result.matches = result.positions.length;

        const freespinResults = this.processFreespinData(record, data, result);

        return [result, ...freespinResults];
    }
}

export default new ScatterResultBuilder();
